import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { HeaderComponent } from '../header/header.component';
import {LoadingController, ModalController} from '@ionic/angular';
import * as moment from 'moment';
import { EChartOption } from 'echarts';

@Component({
  selector: 'app-statistics-of-days-abroad',
  templateUrl: './statistics-of-days-abroad.component.html',
  styleUrls: ['./statistics-of-days-abroad.component.scss'],
})
export class StatisticsOfDaysAbroadComponent implements OnInit {
  @ViewChild('StatisticsOfDaysAbroadHeader') StatisticsOfDaysAbroadHeader: HeaderComponent;
  startDate: string;
  endDate: string;
  defaultLang: string;
  chartOption: EChartOption = {};

  constructor(
      public modalController: ModalController,
      public loadingController: LoadingController,
  ) {
    this.chartOption = {};
  }

  ngOnInit() {}

  changeDate(event, timeName) {
    if (timeName === 'startDate') {
      this.startDate = event;
    }
    if (timeName === 'endDate') {
      this.endDate = event;
    }
    if (this.startDate && this.endDate) {
      this.confirm();
    }

    if (this.startDate && this.endDate) {
    //
    //   const i = moment(this.applicationDetailData['endDate']).valueOf() - moment(this.applicationDetailData['startDate']).valueOf();
    //
    //   if (i < 0) {
    //     this.applicationDetailData[timeName] = null;
    //     return alert('开始时间必须小于结束时e must earlier than EndDate!');
    //   }
    //   const startTime = moment(this.applicationDetailData['startDate']);
    //   const endTime = moment(this.applicationDetailData['endDate']);
    //   const diff = endTime.diff(startTime, 'days');
    //   this.applicationDetailData['leaveDays'] = diff + 1;
    //   console.log(this.applicationDetailData['leaveDays']);
      this.drawCharts();
    }
  }

  drawCharts() {
    this.chartOption = {
      color: ['#D20F1D', '#E2E8ED'],
      series: [{
        name: '',
        type:  'pie',
        radius: ['75%', '85%'], // [内环形半径，外环形半径]如果内环形半径为0，则为饼状图
        avoidLabelOverlap: true,
        hoverAnimation: false,
        label: {
          normal: {
            show: false,
            position: 'center'
          },
          emphasis: {
            show: false
          }
        },
        labelLine: {
          normal: {
            show: false
          }
        },
        // itemStyle: {
        //   barBorderRadius: '50%'
        // },
        data: [5, 10] // 第一个为驻外天数，第二个为用户选择的时间范围
      }],
      graphic: [{ // graphic 是原生图形元素组件
        type: 'text', // 一个图形元素，类型是 text
        top: 'center',
        left: 45,
        style: {
          text: '15', // 可以用‘\n’来换行
          textAlign: 'center',
          fontSize: 48,
          fontWeight: 'bold',
          fontFamily: 'Akrobat',
      }
      }, {
        type: 'text', // 一个图形元素，类型是 text
        top: 70,
        left: 85,
        style: {
          text: '天', // 可以用‘\n’来换行
          textAlign: 'right',
          fontSize: 14,
        }
      }]
    };
  }

  async confirm() {
    await this.presentLoading();
    // if (this.startDate !== '' && this.endDate !== '') {
    //   const i = moment(this.endDate).valueOf() - moment(this.startDate).valueOf();
    //   if (i < 0) {
    //     this.startDate = '';
    //     this.endDate = '';
    //     return alert(this.defaultLang === 'zh' ? '开始时间必须小于结束时间' : 'StartDate must earlier than EndDate!');
    //   } else {
    //     const param = {
    //       crewId: localStorage.getItem('crewId'),
    //       startDateUtc: moment(this.startDate).startOf('d').utc().format('YYYY-MM-DD HH:mm:ss'),
    //       endDateUtc: moment(this.endDate).startOf('d').utc().format('YYYY-MM-DD HH:mm:ss'),
    //     };
    //     const result = await this.calendarPairingService.getFltRosters(param).toPromise();
    //     this.rosterList = result ? result['data'] : [];
    //     // console.log(result);
    //   }
    // }
    await this.closeLoading();
  }

  async presentLoading() {
    const loading = await this.loadingController.create({
      message: this.defaultLang === 'zh' ? '加载中，请稍候...' : 'Loading , please wait...'
    });
    await loading.present();
  }

  closeLoading() {
    this.loadingController.dismiss({
      'dismissed': true
    });
  }

  close() { // 关闭航后数据
    this.dismiss();
  }

  dismiss() {
    // using the injected ModalController this page
    // can 'dismiss' itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true,
      // 'airport': this.airport // 传出机场三字码
    });
  }
}
